export default __webpack_public_path__ + "static/media/225.d25f9ab3.jpg";